import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';

import { useAutoCaptureSDK } from './dataCheckerSDK';

const OpenSdkCameraDisclaimer = ({
  setSdkSuccess,
  setSdkError,
  setSdkCapturedDocument,
  dcAllowedDocument,
  sdkMode,
}: {
  setSdkSuccess: (success: boolean) => void;
  setSdkError: (error: boolean) => void;
  setSdkCapturedDocument: any;
  dcAllowedDocument: Record<string, any>;
  sdkMode: string;
}) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const autoCaptureSDK = useAutoCaptureSDK();
  const { t } = useTranslation(['candidate_recruiter']);

  return (
    <Box
      mb={2}
      mt={4}
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      justifyContent="flex-start"
      minHeight="80vh"
      className="tag-ds"
    >
      <Box>
        <h2>{t('candidate_recruiter:GENERAL.GENERIC.dcSdkCapturePhoto.description')}</h2>
        <ul
          style={{
            backgroundColor: '#F8F8F9',
            fontSize: '16px',
            borderRadius: '8px',
            padding: '16px 16px 16px 32px',
            marginTop: '24px',
          }}
        >
          <li>{t('candidate_recruiter:GENERAL.GENERIC.dcSdkCapturePhoto.instruction1')}</li>
          <li>{t('candidate_recruiter:GENERAL.GENERIC.dcSdkCapturePhoto.instruction2')}</li>
        </ul>
      </Box>
      <Box py={2}>
        <Box pt={1}>
          <div id="autocapture-container" ref={containerRef} style={{ width: '100%', height: '100%', zIndex: 10000 }} />
          <Box
            sx={{
              position: {
                xs: 'fixed',
                sm: 'fixed',
                md: 'static',
              },
              bottom: {
                xs: 0,
                sm: 0,
              },
              left: {
                xs: 0,
                sm: 0,
              },
              width: '100%',
              padding: '16px',
              paddingBottom: 'calc(env(safe-area-inset-bottom) + 32px)',
              zIndex: 1000,
            }}
          >
            <LoadingButton
              variant="contained"
              color="primary"
              type="submit"
              onClick={() =>
                autoCaptureSDK(
                  containerRef,
                  setSdkSuccess,
                  setSdkError,
                  setSdkCapturedDocument,
                  dcAllowedDocument,
                  sdkMode,
                )
              }
            >
              {t('candidate_recruiter:GENERAL.GENERIC.dcSdkCapturePhoto.openCamera')}
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default OpenSdkCameraDisclaimer;
